(function () {
  'use strict';
  var d = document, html = d.documentElement, body = d.body;
  var qs = function (s, r) { return (r || d).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var T = window.theme || { routes: {} }, R = T.routes || {};
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fmt = function (c) { return '$' + (c / 100).toFixed(2); };

  var toastEl = qs('#toast'), toastT;
  function toast(msg) { if (!toastEl) return; toastEl.textContent = msg; toastEl.classList.add('show'); clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('show'); }, 3200); }

  // header hides on scroll down, slides back on scroll up
  var hdr = qs('#hdr'), lastY = window.scrollY, ticking = false;
  function anyMenuOpen() { return !!qs('.mm.open') || body.classList.contains('is-mnav'); }
  function setBar(show) { body.classList.toggle('hdr-off', show); }
  function onScroll() {
    ticking = false; var y = window.scrollY, dy = y - lastY;
    if (hdr) hdr.classList.toggle('is-line', y > 60);
    if (!anyMenuOpen()) { if (y < 120) setBar(false); else if (dy > 4) setBar(true); else if (dy < -4) setBar(false); }
    lastY = y;
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });

  // mega menu: opens on hover, closes on leaving header + panel, click and keyboard
  var menuBtns = qsa('[data-menu]'), openId = null, closeT = null;
  function mmTop() { if (hdr) html.style.setProperty('--mm-top', Math.max(0, hdr.getBoundingClientRect().bottom) + 'px'); }
  function openMenu(id, focusFirst) {
    clearTimeout(closeT); if (openId === id) return; mmTop(); setBar(false);
    qsa('.mm').forEach(function (m) { var on = m.id === 'mm-' + id; m.classList.toggle('open', on); m.setAttribute('aria-hidden', String(!on)); });
    menuBtns.forEach(function (b) { b.setAttribute('aria-expanded', String(b.getAttribute('data-menu') === id)); });
    openId = id;
    if (focusFirst) { var f = qs('#mm-' + id + ' a'); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 30); }
  }
  function closeMenu() {
    clearTimeout(closeT); if (!openId) return;
    qsa('.mm').forEach(function (m) { m.classList.remove('open'); m.setAttribute('aria-hidden', 'true'); });
    menuBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); }); openId = null;
  }
  function soonClose() { clearTimeout(closeT); closeT = setTimeout(closeMenu, 120); }
  var canHover = matchMedia('(hover: hover) and (pointer: fine)').matches;
  menuBtns.forEach(function (b) {
    var id = b.getAttribute('data-menu');
    if (canHover) b.addEventListener('mouseenter', function () { openMenu(id); });
    b.addEventListener('click', function (e) { if (openId === id && (e.detail === 0 || !canHover)) return closeMenu(); openMenu(id, e.detail === 0); });
    b.addEventListener('keydown', function (e) { if (e.key === 'ArrowDown') { e.preventDefault(); openMenu(id, true); } });
  });
  qsa('.nav a, .hdr__logo').forEach(function (el) { el.addEventListener('mouseenter', function () { if (openId) soonClose(); }); });
  if (hdr) hdr.addEventListener('mouseleave', function () { if (openId) soonClose(); });
  qsa('.mm').forEach(function (m) {
    m.addEventListener('mouseenter', function () { clearTimeout(closeT); });
    m.addEventListener('mouseleave', soonClose);
    m.addEventListener('focusout', function (e) { if (!m.contains(e.relatedTarget) && !(e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('[data-menu]'))) soonClose(); });
  });
  d.addEventListener('click', function (e) { if (openId && !e.target.closest('.mm') && !e.target.closest('[data-menu]')) closeMenu(); });
  window.addEventListener('resize', function () { if (openId) mmTop(); });

  // mobile menu
  var mnav = qs('#mnav'), burger = qs('[data-mnav]'), cartEl = qs('#cart'), lastFocus = null;
  function mnavOpen(open) {
    if (!mnav) return;
    if (open) { mmTop(); setBar(false); if (cartEl && cartEl.classList.contains('open')) openCart(false); }
    mnav.classList.toggle('open', open); mnav.setAttribute('aria-hidden', String(!open));
    body.classList.toggle('is-mnav', open); body.classList.toggle('lock', open);
    if (burger) { burger.setAttribute('aria-expanded', String(open)); burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu'); }
  }
  if (burger) burger.addEventListener('click', function () { mnavOpen(!mnav.classList.contains('open')); });
  qsa('a', mnav || d.createElement('i')).forEach(function (a) { a.addEventListener('click', function () { if ((a.getAttribute('href') || '').indexOf('#') > -1) mnavOpen(false); }); });

  // cart drawer: Ajax Cart API + Section Rendering API (the drawer is Liquid, re-rendered after every change)
  function openCart(open) {
    cartEl = qs('#cart'); if (!cartEl) return;
    if (open) { closeMenu(); mnavOpen(false); setBar(false); var an = qs('.ann'), ah = an ? an.offsetHeight : 0; html.style.setProperty('--cart-top', (Math.max(0, ah - window.scrollY) + (hdr ? hdr.offsetHeight : 0)) + 'px'); lastFocus = d.activeElement; }
    body.classList.toggle('is-cart', open);
    cartEl.classList.toggle('open', open); cartEl.setAttribute('aria-hidden', String(!open)); body.classList.toggle('lock', open);
    if (open) { var c = qs('[data-cart-close].ibtn', cartEl); if (c) setTimeout(function () { c.focus({ preventScroll: true }); }, 80); }
    else if (lastFocus && lastFocus.focus) { lastFocus.focus({ preventScroll: true }); lastFocus = null; }
  }
  function paintCart(htmlText) {
    if (!htmlText) return;
    var doc = new DOMParser().parseFromString(htmlText, 'text/html');
    ['#cart-body', '#cart-foot'].forEach(function (s) { var a = qs(s), b = qs(s, doc); if (a && b) { a.innerHTML = b.innerHTML; a.setAttribute('style', b.getAttribute('style') || ''); } });
    var nb = qs('#cart-body', doc), n = nb ? +nb.getAttribute('data-count') : 0, cc = qs('.cart-count');
    if (cc) { cc.textContent = n; cc.classList.toggle('has', n > 0); }
  }
  function cartReq(url, payload) {
    payload.sections = 'cart-drawer'; payload.sections_url = window.location.pathname;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j && j.status && j.description) throw new Error(j.description); paintCart(j.sections && j.sections['cart-drawer']); return j; });
  }
  function addVariant(id, qty) { return cartReq((R.add || '/cart/add') + '.js', { items: [{ id: +id, quantity: qty || 1 }] }); }
  function changeLine(line, qty) { return cartReq((R.change || '/cart/change') + '.js', { line: +line, quantity: +qty }); }
  qsa('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function () { openCart(!(cartEl && cartEl.classList.contains('open'))); }); });
  d.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) return openCart(false);
    var q = e.target.closest('#cart [data-line]'), up = e.target.closest('#cart [data-upgrade]');
    if (q) { q.disabled = true; changeLine(q.getAttribute('data-line'), q.getAttribute('data-qty')).catch(function (er) { toast(er.message); }); }
    if (up) {
      var to = up.getAttribute('data-upgrade'), sw = up.getAttribute('data-swap'); up.disabled = true;
      (sw ? changeLine(sw, 0).then(function () { return addVariant(to, 1); }) : addVariant(to, 1)).then(function () { toast('Cart updated.'); }).catch(function (er) { toast(er.message); });
    }
  });

  // product page: bundle options are variants; the set option adds the set product; no discount codes here
  var pd = qs('#plans-data'), PL = {}, sel = null;
  try { if (pd) { var pj = JSON.parse(pd.textContent); PL = pj.plans || {}; sel = pj.def; } } catch (er) {}
  var dd = qs('.satc__dd'), ddBtn = dd ? qs('[data-dd]', dd) : null, menu = qs('#satc-menu');
  if (menu && pd) menu.innerHTML = Object.keys(PL).map(function (k) { var p = PL[k]; return '<li role="option" tabindex="-1" data-pick="' + k + '" aria-selected="' + (k === sel) + '"><b>' + esc(p.short || p.name) + (p.flag ? ' <em>' + esc(p.flag) + '</em>' : '') + '</b><small>' + p.per + (p.club ? ' \u00b7 Club ' + fmt(p.club) : '') + '</small></li>'; }).join('');
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function paintPlan() {
    var p = PL[sel]; if (!p) return;
    qsa('.plan').forEach(function (l) { var on = l.getAttribute('data-plan') === sel; l.classList.toggle('is-on', on); var i = qs('input', l); if (i) i.checked = on; });
    var ab = qs('#add-btn'); if (ab) ab.textContent = 'Add to cart \u00b7 ' + p.per;
    var bi = qs('[data-buy-id]'); if (bi) bi.value = p.v;
    var sp = qs('#satc-plan'); if (sp) sp.textContent = p.name + (p.flag ? ' (' + p.flag + ')' : '');
    var ss = qs('#satc-sub'); if (ss) ss.textContent = p.sub;
    var sb = qs('#satc-btn'); if (sb) sb.textContent = 'Add to cart \u00b7 ' + p.per;
    var cp = qs('[data-close-price]'); if (cp) cp.textContent = p.per;
    var cc = qs('[data-close-club]'); if (cc && p.club) cc.textContent = 'Club price ' + fmt(p.club);
    qsa('[data-pick]').forEach(function (o) { o.setAttribute('aria-selected', String(o.getAttribute('data-pick') === sel)); });
  }
  qsa('.plan input').forEach(function (r) { r.addEventListener('change', function () { sel = r.value; paintPlan(); }); });
  qsa('.plan').forEach(function (c) { c.addEventListener('click', function (e) { if (e.target.closest('.plan__top')) return; if (!c.classList.contains('is-on')) { sel = c.getAttribute('data-plan'); paintPlan(); } }); });
  function ddOpen(o) { if (!dd) return; dd.classList.toggle('open', o); ddBtn.setAttribute('aria-expanded', String(o)); if (o) { var f = qs('[aria-selected=true]', dd); if (f) f.focus(); } }
  if (dd) {
    ddBtn.addEventListener('click', function () { ddOpen(!dd.classList.contains('open')); });
    qsa('[data-pick]', dd).forEach(function (o) {
      var pick = function () { sel = o.getAttribute('data-pick'); paintPlan(); ddOpen(false); ddBtn.focus(); };
      o.addEventListener('click', pick);
      o.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); }
        else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); var n = e.key === 'ArrowDown' ? o.nextElementSibling : o.previousElementSibling; if (n) n.focus(); }
        else if (e.key === 'Escape') { e.stopPropagation(); ddOpen(false); ddBtn.focus(); }
      });
    });
    d.addEventListener('click', function (e) { if (!e.target.closest('.satc__dd')) ddOpen(false); });
  }
  function addSelected(btn) {
    var p = PL[sel]; if (!p) return;
    if (btn) btn.disabled = true;
    addVariant(p.v, 1).then(function () { openCart(true); }).catch(function (er) { toast(er.message); }).then(function () { if (btn) btn.disabled = false; });
  }
  qsa('[data-add]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); addSelected(b); }); });
  var bf = qs('#buy-form'); if (bf) bf.addEventListener('submit', function (e) { e.preventDefault(); addSelected(qs('#add-btn')); });
  paintPlan();

  // sticky add to cart
  var satc = qs('#satc'), addBtn = qs('#add-btn');
  function satcShow(show) { satc.classList.toggle('show', show); satc.setAttribute('aria-hidden', String(!show)); body.classList.toggle('has-satc', show); qsa('a,button', satc).forEach(function (el) { el.tabIndex = show ? 0 : -1; }); if (!show && dd) ddOpen(false); }
  if (satc && addBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { satcShow(!es[0].isIntersecting && es[0].boundingClientRect.top < 0); }).observe(addBtn);
    var satcT; window.addEventListener('scroll', function () { clearTimeout(satcT); satcT = setTimeout(function () { satcShow(addBtn.getBoundingClientRect().bottom < 0); }, 120); }, { passive: true });
  }

  // gallery
  var gm = qs('#gal-main img'), gns = qsa('[data-gcount]'), gths = qsa('.gal__th button');
  function gStep(dir) { var i = gths.findIndex(function (x) { return x.getAttribute('aria-current') === 'true'; }); var n = gths[(i + dir + gths.length) % gths.length]; if (n) { n.click(); n.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduce ? 'auto' : 'smooth' }); } }
  qsa('[data-gstep]').forEach(function (b) { b.addEventListener('click', function () { gStep(+b.getAttribute('data-gstep')); }); });
  var gmain = qs('#gal-main'), gsx = null;
  if (gmain) { gmain.addEventListener('touchstart', function (e) { gsx = e.touches[0].clientX; }, { passive: true }); gmain.addEventListener('touchend', function (e) { if (gsx === null) return; var dx = e.changedTouches[0].clientX - gsx; if (Math.abs(dx) > 40) gStep(dx < 0 ? 1 : -1); gsx = null; }); }
  gths.forEach(function (b, bi) { b.addEventListener('click', function () {
    if (!gm) return;
    gns.forEach(function (g) { g.textContent = (bi + 1) + ' / ' + gths.length; });
    var full = b.getAttribute('data-full'), half = b.getAttribute('data-half');
    gm.style.opacity = '0'; var im = new Image(); im.src = full;
    var swap = function () { gm.srcset = half + ' 800w, ' + full + ' 1600w'; gm.src = full; gm.alt = b.getAttribute('data-alt'); gm.style.opacity = '1'; };
    (im.decode ? im.decode() : Promise.resolve()).then(swap, swap);
    gths.forEach(function (x) { x.setAttribute('aria-current', String(x === b)); });
  }); });

  // club lightbox: native Shopify customer form (tag club); data-klaviyo-list is the hook for the brand's list
  var bx = qs('#clubbox'), clast = null;
  function clubOpen(o) {
    if (!bx) return false; if (!o && !bx.classList.contains('open')) return false;
    bx.classList.toggle('open', o); bx.setAttribute('aria-hidden', String(!o)); body.classList.toggle('is-lock', o);
    if (o) { clast = d.activeElement; setTimeout(function () { var i = qs('input[type=email]', bx); if (i) i.focus(); }, 60); } else if (clast) clast.focus();
    return true;
  }
  d.addEventListener('click', function (e) { if (e.target.closest('[data-club]')) { e.preventDefault(); if (cartEl && cartEl.classList.contains('open')) openCart(false); clubOpen(true); } else if (e.target.closest('[data-club-close]')) clubOpen(false); });
  if (bx) {
    var cf = qs('form', bx);
    if (cf) cf.addEventListener('submit', function (e) {
      var i = qs('input[type=email]', cf);
      if (!/^\S+@\S+\.\S+$/.test(i.value)) { e.preventDefault(); i.setAttribute('aria-invalid', 'true'); i.focus(); return; }
      d.dispatchEvent(new CustomEvent('club:join', { detail: { email: i.value, list: bx.getAttribute('data-klaviyo-list') || '' } }));
    });
    if (qs('[data-club-joined]', bx)) { qs('.clubbox__f', bx).innerHTML = '<span class="eyebrow">Welcome</span><h2 class="h3">You are in the ' + esc(T.club) + '.</h2><p>Your member price applies at checkout.</p>'; clubOpen(true); }
  }

  // sticky bar steps aside while an email field has focus
  d.addEventListener('focusin', function (e) { if (e.target.matches && e.target.matches('input[type=email]')) body.classList.add('satc-hide'); });
  d.addEventListener('focusout', function (e) { if (e.target.matches && e.target.matches('input[type=email]')) body.classList.remove('satc-hide'); });

  // escape closes whatever is open
  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (clubOpen(false)) return;
    if (dd && dd.classList.contains('open')) { ddOpen(false); ddBtn.focus(); return; }
    if (cartEl && cartEl.classList.contains('open')) return openCart(false);
    if (openId) { var b = qs('[data-menu="' + openId + '"]'); closeMenu(); if (b) b.focus(); return; }
    mnavOpen(false);
  });

  // smooth accordion
  if (!reduce) qsa('.acc details').forEach(function (dt) {
    var s = qs('summary', dt), a = qs('.ans', dt); if (!s || !a) return;
    s.addEventListener('click', function (ev) {
      ev.preventDefault(); if (dt._anim) return;
      var open = dt.open, pb = getComputedStyle(a).paddingBottom; a.style.overflow = 'hidden';
      if (!open) { dt.open = true; var h = a.scrollHeight; a.style.height = '0px'; a.style.paddingBottom = '0px'; a.style.opacity = '0'; void a.offsetHeight; requestAnimationFrame(function () { a.style.transition = 'height .38s cubic-bezier(.2,.8,.2,1), padding .38s cubic-bezier(.2,.8,.2,1), opacity .3s ease'; a.style.height = h + 'px'; a.style.paddingBottom = pb; a.style.opacity = '1'; }); }
      else { a.style.height = a.scrollHeight + 'px'; void a.offsetHeight; requestAnimationFrame(function () { a.style.transition = 'height .34s cubic-bezier(.4,0,.2,1), padding .34s cubic-bezier(.4,0,.2,1), opacity .22s ease'; a.style.height = '0px'; a.style.paddingBottom = '0px'; a.style.opacity = '0'; }); }
      dt._anim = true; setTimeout(function () { if (open) dt.open = false; a.style.cssText = ''; dt._anim = false; }, open ? 360 : 400);
    });
  });
})();
